import React,{useEffect,useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {normalizeLanguage} from './languages';
import '../styles/fit-text.css';

// Only adjusts the label's font size. The original button supplies its bounds.
export default function FitText({children,maxFontSize=16,className='',style,foreignOnly=false}){
 const {i18n}=useTranslation('translations'),box=useRef(null),content=useRef(null);
 const fitEnabled=!foreignOnly||normalizeLanguage(i18n.language)!=='zh-Hant';
 useEffect(()=>{
  if(!fitEnabled||!box.current||!content.current)return;
  let active=true,frame=null;
  const fit=()=>{
   if(!active||!box.current||!content.current)return;
   const outer=box.current,inner=content.current,w=outer.clientWidth,h=outer.clientHeight;
   if(!w||!h)return;
   const fits=()=>inner.scrollWidth<=w&&inner.getBoundingClientRect().height<=h;
   inner.style.fontSize=maxFontSize+'px';
   if(fits())return;
   let low=6,high=maxFontSize;
   for(let i=0;i<8;i++){const mid=(low+high)/2;inner.style.fontSize=mid+'px';if(fits())low=mid;else high=mid;}
   inner.style.fontSize=Math.floor(low*10)/10+'px';
  };
  const schedule=()=>{if(frame!==null)window.cancelAnimationFrame(frame);frame=window.requestAnimationFrame(fit);};
  fit();
  const observer=typeof ResizeObserver==='function'?new ResizeObserver(schedule):null;
  if(observer)observer.observe(box.current);
  window.addEventListener('resize',schedule);window.addEventListener('load',schedule,true);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(()=>{if(active)schedule();});
  return()=>{active=false;if(frame!==null)window.cancelAnimationFrame(frame);if(observer)observer.disconnect();window.removeEventListener('resize',schedule);window.removeEventListener('load',schedule,true);};
 },[children,maxFontSize,fitEnabled,i18n.language]);
 if(!fitEnabled)return <span>{children}</span>;
 return <span ref={box} className={'op-fit-text '+className} style={style}><span ref={content} className="op-fit-text__content" style={{fontSize:maxFontSize}}>{children}</span></span>;
}
